import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { animate, style, transition, trigger } from '@angular/animations';
import type { UploadFileStatus } from '../../../models/upload.model';

@Component({
    selector: 'app-file-upload-status',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './file-upload-status.component.html',
    styleUrl: './file-upload-status.component.scss',
    animations: [
        trigger('fadeExit', [
            transition(':leave', [
                animate('300ms ease-in', style({ opacity: 0, transform: 'translateX(20px)' }))
            ])
        ])
    ]
})
export class FileUploadStatus {
    uploads = input<UploadFileStatus[]>([]);
}
